import api from "@/api/api";
import { STATUS_HTTP } from "@/api/statusHTTP";
import { iniciarRequisicao, logout } from "@/helpers";

const PREFIXO = '/drp';

export const buscarListasDePedidosVencidosDrp = async (parametros) => {
  const url = `${PREFIXO}/listas-de-pedidos-vencidos-drp`;

  const { data, status } = await api.get(url, { parametros, headers: iniciarRequisicao()}).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.dados;
}

export const finalizarPedidosVencidosDrp = async (parametros) => {
  const { data, status } = await api.post(`${PREFIXO}/finalizar-pedidos-vencidos-drp`, parametros, {headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) logout();
  localStorage.token = data.token;
  return data.dados;
}
